import React, { useContext } from 'react';
import { styled } from '@volkswagen-onehub/components-core';
import ColorDetail from '../ColorDetail';
import { VehicleContext } from '../../utils/vehicle-context';
import { getLang, getTranslations } from '../../translations';
import { VehicleData } from '../../types';

const ColorContainer = styled.div`
  display: flex;
  flex-direction: column;
  column-gap: ${props =>  props.theme.size.dynamic0050};
  row-gap: ${props =>  props.theme.size.dynamic0020};
`;

export const Colours = () => {
  const lang = getLang();
  const vehicle = useContext(VehicleContext) as VehicleData;
  const { color_exterior, color_interior } = vehicle;

  const { labels } = getTranslations();

  const exteriorLabel = labels.exterior;
  const interiorLabel = labels.interior;

  return (
    <ColorContainer>
      {color_exterior && color_exterior.label && color_exterior.value && <ColorDetail name={color_exterior.label[lang]} hex={color_exterior.value} label={exteriorLabel} /> }
      {color_interior && color_interior.label && color_interior.value && <ColorDetail name={color_interior.label[lang]} hex={color_interior.value} label={interiorLabel} /> }
    </ColorContainer>
  );
};
